<template>
  <el-table-column
    prop="customer_delivery_address"
    label="Vevő szállítási címe"
    show-overflow-tooltip
    sortable="custom"
    min-width="190"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_delivery_address }}
    </template>
  </el-table-column>
</template>
<script>
export default {
  propName: 'customer_delivery_address',
};
</script>
